import ChartBar from '../../../components/ChartBar';
import { buildReportChartData } from '../../../data/report/helpers/chartUtils';
import { getAccountType } from '../../../data/report/helpers/pricebookReportUtils';
import { RecentPlatformData, SummedReport } from '../../../models/ReportData';
import useChartTheme from '../../../themes/chart';

const primaryPlatformMap = new Map<keyof RecentPlatformData, string>([
  ['recentPlatformWebCount', 'Desktop'],
  ['recentPlatformAppleMobileCount', 'Apple (mobile)'],
  ['recentPlatformAppleWebCount', 'Apple (web)'],
  ['recentPlatformAndroidMobileCount', 'Android (mobile)'],
  ['recentPlatformAndroidWebCount', 'Android (web)'],
]);

interface PrimaryPlatformChartProps {
  summedReport: SummedReport;
}

const PrimaryPlatformChart: React.FC<PrimaryPlatformChartProps> = ({ summedReport }) => {
  const { chartColors } = useChartTheme();
  const chartData = buildReportChartData(
    summedReport,
    pricebookReport => getAccountType(pricebookReport?.productType),
    primaryPlatformMap,
  );

  const dataSeries = Object.entries(chartData).map(([accountType, data]) => ({
    data,
    color: chartColors[accountType as keyof typeof chartColors],
    label: accountType,
  }));

  return (
    <ChartBar
      title='Users per primary platform'
      dataSeries={dataSeries}
      yAxisLabel='Count per primary platform'
      seriesLabel='Account type'
      padding={{ bottom: 85 }}
    />
  );
};

export default PrimaryPlatformChart;
